<template>
  <div class="review-rate me-1">
    <ul class="review-star">
      <li class="active" :key="x" v-for="x in fullStars"><i class="fa fa-star"></i></li>
      <li class="" :key="x" v-for="x in emptyStars"><i class="fa fa-star-o"></i></li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'Rating',
  props: { rate: { type: Number, default: 5 } },
  data() {
    return {
      fullStars: Math.trunc(this.rate),
      emptyStars: 5 - Math.trunc(this.rate),
      hasHalfStar: this.rate % 1 >= 0.5
    }
  }
}
</script>
<style lang="scss">
.rating-lg .fa {
  font-size: 2em;
}

</style>



// WEBPACK FOOTER //
// src/components/Rating.vue